export default __webpack_public_path__ + "assets/856662f92264da838390c6f76da6df8d.svg";